import { CloseCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row, Typography } from "antd";

export const MetricsWorkshop = ({ value = [], onChange, showVariation = false, addLabel = "Agregar métrica" }) => {
    const metricsWorkshop = value || [];

    const handleAddMetric = () => {
        onChange([
            ...metricsWorkshop,
            {
                id: metricsWorkshop.length
                    ? metricsWorkshop[metricsWorkshop.length - 1].id + 1
                    : 0,
                metric: "",
                description: "",
                volume: "",
                ...(showVariation ? { variation: "" } : {}),
            },
        ]);
    };

    const handleChange = (idx, field, val) => {
        const updated = [...metricsWorkshop];
        updated[idx][field] = val;
        onChange(updated);
    };

    const handleRemove = (idx) => {
        const updated = [
            ...metricsWorkshop.slice(0, idx),
            ...metricsWorkshop.slice(idx + 1),
        ];
        onChange(updated);
    };

    const canAddMetric =
        metricsWorkshop.length === 0 ||
        (
            metricsWorkshop[metricsWorkshop.length - 1].metric.trim() !== "" &&
            metricsWorkshop[metricsWorkshop.length - 1].description.trim() !== "" &&
            metricsWorkshop[metricsWorkshop.length - 1].volume.trim() !== ""
        );

    return (
        <Card
            style={{
                border: "1px solid #d9d9d9",
                borderRadius: 8,
                boxShadow: "0 1px 1px #f0f1f2",
                padding: 16,
                marginBottom: 14,
            }}
        >
            <Row justify="end">
                <Col>
                    <Button
                        onClick={handleAddMetric}
                        disabled={!canAddMetric}
                    >
                        <PlusCircleOutlined />
                        {addLabel}
                    </Button>
                </Col>
            </Row>
            {metricsWorkshop.map((item, idx) => (
                <Row key={idx} gutter={[16, 16]} justify="start" align="stretch" style={{ marginTop: 12 }}>
                    <Col span={showVariation ? 6 : 8}>
                        <Typography.Title style={{ margin: 5, fontSize: 14, textAlign: "left" }}>Métrica</Typography.Title>
                        <Input
                            placeholder="Métrica (Ej: Tasa de conversión)"
                            value={item.metric}
                            onChange={e => handleChange(idx, "metric", e.target.value)}
                        />
                    </Col>
                    <Col span={showVariation ? 7 : 8}>
                        <Typography.Title style={{ margin: 5, fontSize: 14, textAlign: "left" }}>Descripción</Typography.Title>
                        <Input
                            placeholder="Descripción (Ej: Reducción de tiempo en resolución)"
                            value={item.description}
                            onChange={e => handleChange(idx, "description", e.target.value)}
                        />
                    </Col>
                    <Col span={showVariation ? 5 : 7}>
                        <Typography.Title style={{ margin: 5, fontSize: 14, textAlign: "left" }}>Volumen</Typography.Title>
                        <Input
                            placeholder="Volumen (Ej: 99.9%)"
                            value={item.volume}
                            onChange={e => handleChange(idx, "volume", e.target.value)}
                        />
                    </Col>
                    {showVariation && (
                        <Col span={5}>
                            <Typography.Title style={{ margin: 5, fontSize: 14, textAlign: "left" }}>Variación</Typography.Title>
                            <Input
                                placeholder="Variación (Ej: -90%)"
                                value={item.variation || ""}
                                onChange={e => handleChange(idx, "variation", e.target.value)}
                            />
                        </Col>
                    )}
                    <Col span={1}>
                        <Button
                            shape="circle"
                            style={{ marginLeft: 8, backgroundColor: "red" }}
                            icon={<CloseCircleOutlined />}
                            onClick={() => handleRemove(idx)}
                        />
                    </Col>
                </Row>
            ))}
        </Card>
    );
};
